<template>
  <ZoomOneEduPlanDetail
    :class="{ 'opc-modal-dialog': isLegacyModalUI }"
    :show-close="!isLegacyModalUI"
    v-bind="{
      visible,
      id,
      currencySymbol,
      enableDisplayZoomWorkFlow,
      enableDisplayZoomDrive,
      bizCategoryCode,
      largeMeetingCallback,
      fullListCallBack,
      enableDocsFeature,
      enableDisplayZoomTasksWithoutAccountCheck,
      isEligibleAccount4CustomAvatarFeature,
      enableLargeMeeting3k5k,
      enableEduWorkspaceReservations
    }"
    @closed="handleCancel"
  >
    <template v-if="isLegacyModalUI" #back>
      <NavBack :backHandler="handleCancel" class="mb24" />
    </template>
    <template #footer>
      <p class="opc-zeduschp-detail-tip">
        *{{ $t('billing.zone.edu_details.tips', [20, $money(annualPriceNum * 20, { forceDiff: true })]) }}
      </p>
    </template>
  </ZoomOneEduPlanDetail>
</template>

<script>
import { mapGetters } from 'vuex';

import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from '@/utils/currency';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import NavBack from '@/components/nav-back.vue';
import { ZoomOneEduPlanDetailDialog } from "@zoom/fe-billing-components";

export default {
  name: 'ZEduPlusPlanDetail',
  mixins: [ConfirmComponent],
  components: {
    NavBack,
    ZoomOneEduPlanDetail: ZoomOneEduPlanDetailDialog
  },
  props: {
    bizCategoryCode: String,
    fullListCb: Function,
    largeMeetingCb: Function,
  },
  data() {
    return {
      visible: false,
      id: 'schoolPlus',
      currencySymbol: getCurrencySymbol(getCurrency()),
      enableDocsFeature: window.newBillingConfig.enableDocsFeature,
      enableLargeMeeting3k5k: window.newBillingConfig.enableLargeMeeting3k5k,
      enableDisplayZoomTasksWithoutAccountCheck: window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck,
      isEligibleAccount4CustomAvatarFeature: window.newBillingConfig.isEligibleAccount4CustomAvatarFeature,
      enableDisplayZoomWorkFlow: window.newBillingConfig.enableDisplayZoomWorkFlow,
      enableDisplayZoomDrive: window.newBillingConfig.enableDisplayZoomDrive,
      enableEduWorkspaceReservations: window.newBillingConfig.wsrVM4SchoolOnline,
    }
  },
  computed: {
    ...mapGetters(['planMapFlat']),
    isLegacyModalUI() {
      return this.$context?.is?.modal && !this.$context?.is?.modal2Column;
    },
    annualPriceNum() {
      const zoneBundlePlans = plansof(this.planMapFlat).type(planTypes.ZONE_EDU_PLUS).annual();
      const category0 = zoneBundlePlans.clone().get(0)?.category;
      return zoneBundlePlans.category(category0).sum('price');
    },
    largeMeetingCallback() {
      if (typeof this.largeMeetingCb == 'function') {
        return () => {
          this.largeMeetingCb()
          this.handleCancel()
        }
      }
      return null
    }
  },
  methods: {
    fullListCallBack() {
      typeof this.fullListCb == 'function' && this.fullListCb()
      this.handleCancel()
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/modal.scss';
</style>
